import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/form-control'
import {
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
} from '@chakra-ui/input'
import { Spinner } from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'

interface TextFieldProps<T> {
  name: keyof T
  currency: string
  label: string
  required?: boolean
  placeholder?: string
  disabled?: boolean
  loading?: boolean
}

const CURRENCY_SYMBOLS = {
  USD: '$',
  INR: '₹',
}

function MoneyField<T>({
  name,
  label,
  required,
  placeholder,
  currency,
  disabled,
  loading,
}: TextFieldProps<T>): React.ReactElement {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps<string, T>) => (
        <FormControl
          name={field.name}
          isInvalid={Boolean(!form.isValid && form.errors[field.name])}
          isRequired={required}
        >
          <FormLabel>{label}</FormLabel>
          <InputGroup>
            <InputLeftAddon
              children={
                CURRENCY_SYMBOLS[currency.toUpperCase()] ?? CURRENCY_SYMBOLS.INR
              }
            />
            <Input
              disabled={disabled}
              {...field}
              placeholder={placeholder ?? label}
              type="number"
            />
            {loading ? (
              <InputRightElement>
                <Spinner />
              </InputRightElement>
            ) : null}
          </InputGroup>
          <FormErrorMessage marginBottom="-2.0408em">
            {form.errors[field.name]}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default MoneyField
